<template>
  <v-expansion-panel class="idcs-main-back">
    <v-expansion-panel-header v-slot="{ open }">
      <v-layout align-center wrap>
        <v-flex xs12 sm6 md3 lg2 xl2>
          <v-subheader>
            <v-icon class="mr-2 all-ok-icon-color">fa-info</v-icon>
            {{ $t("card.stat") }}
          </v-subheader>
        </v-flex>
        <v-flex xs12 sm6 md9 lg10 xl10>
          <div v-if="!open">
            <v-icon class>fa-shopping-cart</v-icon>
            <v-icon small class="mx-6">fa-arrow-right</v-icon>
            <span class="d-inline-block">
              <span class="text-uppercase mr-2">{{ $t("card.total_deals") }}</span>
              <span class="title">{{ trans }}</span>
              <span>,</span>
            </span>
            <span class="d-inline-block">
              <span class="text-uppercase ml-4 mr-2">{{ $t("card.last_used") }}</span>
              <span class="title">{{ card.last_used | dt-only }}</span>
            </span>
          </div>
        </v-flex>
      </v-layout>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-simple-table>
        <thead>
          <tr>
            <th class="idcs-th-back"></th>
            <th class="idcs-th-back text-center">{{ $t("field.last_used") }}</th>
            <th class="idcs-th-back text-center">{{ $t("card.stats.recr_nr") }}</th>
            <th class="idcs-th-back text-center">{{ $t("card.transCount") }}</th>
            <th class="idcs-th-back text-center">{{ $t("card.logCount") }}</th>
            <th class="idcs-th-back text-center">{{ $t("field.bad_used") }}</th>
            <th class="idcs-th-back text-center">{{ $t("card.stats.created") }}</th>
            <th class="idcs-th-back text-center">{{ $t("field.last_modified") }}</th>
            <th class="idcs-th-back text-center">{{ $t("card.stats.validto") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="idcs-data-back">
              <v-icon class>fa-shopping-cart</v-icon>
            </td>
            <td class="idcs-data-back text-center">{{ card.last_used | dt-sec }}</td>
            <td class="idcs-data-back text-center">
              <v-icon small class="mr-2">mdi-receipt</v-icon>
              {{ card.recr_nr }}
            </td>
            <td class="idcs-data-back text-center">
              <v-chip color="accent">{{ trans }}</v-chip>
            </td>
            <td class="idcs-data-back text-center">{{ logs }}</td>
            <td class="idcs-data-back text-center">
              <v-chip color="error" @click="simpleDialog=true">{{ bad_used }}</v-chip>
            </td>
            <td class="idcs-data-back text-center">{{ card.created | dt-only }}</td>
            <td class="idcs-data-back text-center">{{ card.last_modified | dt-time }}</td>
            <td class="idcs-data-back text-center">{{ card.valid | dt-time }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-expansion-panel-content>
    <DeleteDialog
      v-model="simpleDialog"
      @click:ok="clearBadUsed"
      button="button.ok"
      title="dialog.aconfirm"
      text="dialog.tconfirm"
    />
  </v-expansion-panel>
</template>

<script>
import app from "@/app.js";
import DeleteDialog from "@/components/DeleteDialog.vue";

export default {
  name: "CardStatPanel",
  components: { DeleteDialog },
  props: {
    card: Object,
    trans: Number,
    logs: Number,
  },
  data() {
    return {
      simpleDialog: false,
    };
  },
  computed: {
    bad_used() {
      return this.card.bad_used;
    },
  },
  methods: {
    clearBadUsed() {
      if (!this.$store.getters.test("fcused.y")) return;
      app.clearBadUsed(this.card.id).then((r) => {
        try {
          if (r.result.count) {
            this.card.bad_used = 0;
          }
        } catch (error) {
          console.log(r);
        }
      });
    },
  },
};
</script>

<style scoped>
.all-ok-icon-color {
  color: #81d4fa;
}
</style>
